module.exports = "<nav class=\"leftsettingbox\">\r\n  <ul class=\"list-unstyled settinglist\">  \r\n    <li><a [routerLink]=\"['costCombined']\" hasPermission=\"reports.cost.costCombined.active\" routerLinkActive=\"selected\" ><strong>Combined Report</strong></a></li>\r\n  </ul>     \r\n</nav> \r\n<router-outlet></router-outlet> \r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/cost-control/cost-control.component.html
// module id = ./src/app/reports/cost-control/cost-control.component.html
// module chunks = main